<div class="relative h-screen w-screen">
    <app-alerts></app-alerts>
    <app-loader></app-loader>

    <router-outlet />
</div>
